import React, { Component } from 'react';
import { addTranslation, IntlProps } from 'decorators/addTranslation';
import Form from 'components/ui/form';
import Loader from 'components/ui/loader';
import Button from 'components/ui/button';
import FormField from 'components/formField';
import { scrollToError } from 'components/formFields/helpers';
import FormFieldsProps from './FormFieldsProps';
import { FormField as FormFieldType } from './types';
import './formFields.scss';

interface Props extends FormFieldsProps, IntlProps {
  loadMore?: (name: string) => void;
  isAdditionalLoading?: boolean;
}

class FormFields extends Component<Props> {
  render() {
    const {
      getTranslate,
      isLoading,
      fieldsConfig,
      additionalTitle,
      extraConfig,
      text,
      generalTitle,
      backUrl,
      backText,
      canCreate,
      status,
      repeatCreateButtonText,
      createButtonText,
    } = this.props;
    const additionalFields =
      fieldsConfig &&
      Object.keys(fieldsConfig).filter((key) => key !== 'general');

    return (
      <>
        {isLoading && <Loader />}
        <Form customClass='ui-form-fields__form' onSubmit={this.onSubmit}>
          <div className='ui-form-fields__container ui-form-fields__content'>
            {text && (
              <div className='ui-form-fields__text'>{getTranslate(text)}</div>
            )}
            <div className='ui-form-fields__inner'>
              <div className='ui-form-fields__col ui-form-fields__col_general'>
                <div className='ui-form-fields__col-title'>
                  {getTranslate(generalTitle)}
                </div>
                {this.renderFields(fieldsConfig?.general || [])}
              </div>
              <div className='ui-form-fields__col ui-form-fields__col_additional'>
                <div className='ui-form-fields__col-title'>
                  {getTranslate(additionalTitle)}
                </div>
                {additionalFields?.length
                  ? additionalFields.map((section) => {
                    return this.renderFields(fieldsConfig?.[section]);
                  })
                  : null}
              </div>
            </div>

            {extraConfig ? (
              <div className='ui-form-fields__inner'>
                {Object.keys(extraConfig).map((section) => {
                  return (
                    <div className='ui-form-fields__col' key={section}>
                      {this.renderFields(extraConfig[section])}
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>

          <div className='ui-form-fields__container ui-form-fields__container_footer flex items-center'>
            {backUrl ? (
              <Button
                text={getTranslate(backText)}
                status='outline'
                link={backUrl}
              />
            ) : (
              <div />
            )}

            <Button
              disabled={!canCreate}
              text={getTranslate(
                status ? repeatCreateButtonText : createButtonText
              )}
              loading={isLoading}
              status='primary'
              type='submit'
              customClass='ui-form-fields__button'
            />
          </div>
        </Form>
      </>
    );
  }

  renderFields = (fieldsList: Array<FormFieldType | FormFieldType[]>) => {
    const options = {
      fieldsValues: this.props.fieldsValues,
      dictionaries: this.props.dictionaries,
      fieldsState: this.props.fieldsState,
      hiddenFields: this.props.hiddenFields,
      validationErrors: this.props.validationErrors,
      onChange: this.props.onChange,
      loadMore: this.props.loadMore,
      isLoading: this.props.isLoading,
      formClassName: 'ui-form-fields',
    };
    return fieldsList.map((field, i) => {
      if (Array.isArray(field)) {
        return (
          <div
            className='ui-form-fields__item max-tablet:flex-col flex items-start gap-4'
            key={`inner-${i}`}>
            {field.map((innerField) => {
              return (
                <FormField
                  field={innerField}
                  options={options}
                  key={innerField.id}
                />
              );
            })}
          </div>
        );
      }
      return <FormField field={field} options={options} key={field.id} />;
    });
  };

  onSubmit = async () => {
    try {
      await this.props.onSubmit?.();
    } finally {
      scrollToError(this.props.validationErrors);
    }
  };
}

export default addTranslation(FormFields);
